import { saleAggregateRules } from './aggregates.calc.js';
import { gatedSalePriceRelationRules } from './gated-price-relations.calc.js';
import { pgiPerAreaRules } from './pgi-per-area.calc.js';
import { preferredPriceRules } from './preferred-price.calc.js';
import { salePricePerAreaRules } from './price-per-sqft.calc.js';
import { vpvrRules } from './vpvr.calc.js';
import { saleYieldRules } from './yields.calc.js';
export const saleRules = [...salePricePerAreaRules, ...saleAggregateRules, ...gatedSalePriceRelationRules, ...preferredPriceRules, ...vpvrRules, ...pgiPerAreaRules, ...saleYieldRules];
export const saleRegistry = {
  domain: 'sale',
  rules: saleRules
};
